import { render, staticRenderFns } from "./DialogExcecaoClientes.vue?vue&type=template&id=0f3a9986&scoped=true"
import script from "./DialogExcecaoClientes.vue?vue&type=script&lang=js"
export * from "./DialogExcecaoClientes.vue?vue&type=script&lang=js"
import style0 from "./DialogExcecaoClientes.vue?vue&type=style&index=0&id=0f3a9986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a9986",
  null
  
)

export default component.exports